export default [
  {
    path: "/zfsxhv3Thirty",
    name: "zfsxhv3Thirty",
    meta: {
      title: "视宣号标准版"
    },
    component: () => import("@/views/zfsxh/zfsxhv4Baobei")
  }
];



// WEBPACK FOOTER //
// ./src/router/modules/zfsxh.js